import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from "recharts";

export function TRIFRTab({ trifr, summary }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-lg border border-slate-200 bg-white p-6 text-center">
          <div className="text-xs uppercase tracking-wide text-slate-500">TRIFR (per 200,000 hours worked)</div>
          <div className="font-display text-6xl text-gbe mt-2">{summary?.trifr_200k ?? "—"}</div>
          <div className="text-xs text-slate-500 mt-2">Recordable Injuries ÷ Hours × 200,000</div>
        </div>
        <div className="rounded-lg border border-slate-200 bg-white p-6 text-center">
          <div className="text-xs uppercase tracking-wide text-slate-500">TRIFR (per 1,000,000 hours worked)</div>
          <div className="font-display text-6xl text-gbe mt-2">{summary?.trifr_1m ?? "—"}</div>
          <div className="text-xs text-slate-500 mt-2">Industry benchmark base</div>
        </div>
      </div>

      <div className="rounded-lg border border-slate-200 bg-white p-4">
        <div className="text-sm font-medium text-slate-800 mb-3">TRIFR — Monthly Trend</div>
        <ResponsiveContainer width="100%" height={320}>
          <LineChart data={trifr}>
            <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" />
            <XAxis dataKey="month_label" tick={{ fontSize: 11, fill: "#64748B" }} />
            <YAxis tick={{ fontSize: 11, fill: "#64748B" }} />
            <Tooltip contentStyle={{ fontSize: "12px" }} />
            <Legend wrapperStyle={{ fontSize: "11px" }} />
            <Line type="monotone" dataKey="trifr_1m" name="TRIFR (1,000,000)" stroke="#00334C" strokeWidth={3} dot={{ r: 4 }} />
            <Line type="monotone" dataKey="trifr_200k" name="TRIFR (200,000)" stroke="#FCEA00" strokeWidth={2.5} dot={{ r: 4 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
        <div className="grid grid-cols-5 gap-2 px-4 py-2.5 text-[11px] uppercase tracking-wider text-white bg-gbe">
          <div>Month</div>
          <div className="text-right">Recordable Injuries</div>
          <div className="text-right">Hours Worked</div>
          <div className="text-right">TRIFR (200k)</div>
          <div className="text-right">TRIFR (1M)</div>
        </div>
        <div className="divide-y divide-slate-100">
          {trifr.map((row) => (
            <div key={row.month} className="grid grid-cols-5 gap-2 px-4 py-2 text-sm items-center">
              <div className="text-slate-700 font-mono text-xs">{row.month}</div>
              <div className="text-right text-slate-800">{row.recordable}</div>
              <div className="text-right text-slate-500 text-xs">{row.hours.toLocaleString()}</div>
              <div className="text-right text-gbe font-medium">{row.trifr_200k}</div>
              <div className="text-right text-gbe font-semibold">{row.trifr_1m}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
